import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { ProgressDialog } from '@yola/ws-ui';

const defaultCaptions = {};

const getCaptions = (captionsOverrides) => ({
  title: `${i18next.t('Translating your page')}...`,
  ...captionsOverrides,
});

const TranslatePageProgressDialog = ({ captions = defaultCaptions }) => (
  <ProgressDialog
    overlay="visible"
    progressType="indeterminate"
    cancelable={false}
    captions={getCaptions(captions)}
    width={336}
    height={109}
    minHeight={109}
  />
);

TranslatePageProgressDialog.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    cancel: PropTypes.string,
  }),
};

export default TranslatePageProgressDialog;
